import { config } from "./config";
import pepeABI from "./ABIs/pepeABI.json";

const { pepeContractAddress } = config;

/**
 * @see https://etherscan.io/address/0x6982508145454Ce325dDbE47a25d4ec3d2311933#code
 */
export class PepeContractHandler {
  contract: import("./ABIs/pepeABI").ContractContext | null;
  contractAddress: string;
  web3: import("web3").default | null;
  constructor() {
    this.contract = null;
    this.contractAddress = pepeContractAddress;
    this.web3 = null;
  }

  async buildContract(web3: import("web3").default) {
    this.web3 = web3;
    if (pepeABI && this.web3) {
      const artifact = pepeABI;
      this.contract = new web3.eth.Contract(
        artifact as any,
        pepeContractAddress
      ) as any;
      if (this.contract) {
        return true;
      }
      return false;
    }
    console.log("ABI pack json failed to load");
    return false;
  }
}
